export const getTextFields = (resellerData: any) => [
  {
    id: "reseller-name",
    name: "name",
    label: "Company Name",
    type: "text",
    placeholder: "Enter Company Name",
    required: true,
    capitalizedFirst: true,
    value: resellerData?.name,
  },
  {
    id: "reseller-phone",
    name: "phone",
    label: "Phone",
    type: "text",
    placeholder: "Enter Phone",
    required: true,
    capitalizedFirst: false,
    value: resellerData?.organizationProfile?.phone,
  },
  {
    id: "reseller-email",
    name: "email",
    label: "Email",
    type: "text",
    placeholder: "Enter Email",
    required: true,
    capitalizedFirst: false,
    value: resellerData?.organizationProfile?.email,
    disabled: true,
  },

  {
    id: "reseller-domain_name",
    name: "subdomainName",
    label: "Subdomain Name",
    type: "text",
    placeholder: "Enter Subdomain Name",
    required: true,
    capitalizedFirst: false,
    value: resellerData?.subdomainName,
  },

  // {
  //   id: "reseller-domain_name",
  //   name: "domainName",
  //   label: "Domain Name",
  //   type: "hidden",
  //   placeholder: "Enter domain Name",
  //   required: false,
  //   capitalizedFirst: false,
  //   disabled: true,
  //   value: resellerData?.domainName,
  // },
];

export const getAddressTextFields = (adminData: any) => [
  {
    id: "admin-address",
    name: "addressLine1",
    label: "Address ",
    type: "text",
    placeholder: "Enter Address ",
    required: true,
    value: adminData?.addressLine1,
  },
  {
    id: "admin-street",
    name: "streetName",
    label: "Street",
    type: "text",
    placeholder: "Enter Street",
    required: true,
    value: adminData?.streetName,
  },
  {
    label: "Country",
    value: adminData?.country?.map((s: any) => s.label),
    formField: false,
  },
  {
    label: "State",
    value: adminData?.state?.map((s: any) => s.label),
    formField: false,
  },
  {
    label: "City",
    value: adminData?.city?.map((c: any) => c.label),
    formField: false,
  },
  {
    id: "admin-zipCode",
    name: "zipCode",
    label: "Zip Code",
    type: "text",
    placeholder: "Enter Zip Code",
    required: true,
    value: adminData?.zipCode,
  },
  {
    label: "Default Address",
    value: adminData?.defaultAddress === true ? "Yes" : "No",
    formField: false,
  },
];

export const getContactTextFields = (contactData: any) => [
  {
    id: "admin-name",
    name: "name",
    label: "Name ",
    type: "text",
    placeholder: "Enter Name ",
    required: true,
    capitalizedFirst: true,
    value: contactData?.name,
  },
  {
    id: "admin-phone",
    name: "phone",
    label: "Phone",
    type: "text",
    placeholder: "Enter Phone",
    required: true,
    value: contactData?.phone,
  },
  {
    id: "admin-designation",
    name: "designation",
    label: "Designation",
    type: "text",
    placeholder: "Enter Designation",
    required: true,
    value: contactData?.designation,
    capitalizedFirst: true,
  },

  {
    label: "Default Contact",
    value: contactData?.defaultContact === true ? "Yes" : "No",
    formField: false,
  },
];

export const getDomainCreationFields = (domainData: any) => [
  {
    id: "domain-name",
    name: "domainName",
    label: "Domain Name",
    type: "textarea",
    placeholder: "Enter Domain Name",
    required: true,
    value: domainData?.domainName,
  },
];
